export default __webpack_public_path__ + "static/media/ver_incapacidad.41289678.jpeg";